import clasnames from 'classnames';
import React from 'react';

import { PurpleGradientContainer } from '../../components/backdrops/containers';
import PrimaryLink from '../../components/buttons/PrimaryLink';
import pageRoutes from '../../router/pageRoutes';

type PricingCardsProps = { mode: 'light' | 'dark' };

const PricingCards: React.FC<PricingCardsProps> = React.memo((props) => {
  const { mode } = props;
  return (
    <div className="flex flex-col lg:flex-row gap-4 my-4 max-w-[1200px]">
      <div
        className={clasnames('rounded-2xl border-2 py-6 md:py-6 px-6 md:px-16 w-auto lg:w-1/2', {
          'border-pureWhite': mode === 'dark',
          'border-black': mode === 'light',
        })}
      >
        <p>BILLED ANNUALLY</p>
        <h2 className="font-medium">Standard</h2>
        <h2 className="font-medium text-purple">12$</h2>
        <h3 className="text-purple leading-none">Per user per month</h3>
        <ul className="list-disc mt-6 marker:text-purple flex flex-col gap-2 text-xl">
          <li>User Management</li>
          <li>AI-Powered Self Service</li>
          <li>Automated Workflows</li>
          <li>Integrations</li>
          <li>Omni-channel access</li>
        </ul>
      </div>
      <PurpleGradientContainer className="rounded-2xl py-6 md:py-6 px-6 md:px-16 text-pureWhite w-auto lg:w-1/2">
        <p>BILLED ANNUALLY</p>
        <h2>Enterprise</h2>
        <p className="mt-4">End-to-end custom business solution tailored to your needs</p>
        <div className="my-4">
          <PrimaryLink className="border-1 text-pureWhite rounded-full px-4 py-2 text-xl" href={pageRoutes.ContactUs}>
            Contact us
          </PrimaryLink>
        </div>
      </PurpleGradientContainer>
    </div>
  );
});
PricingCards.displayName = 'PricingCards';
export default PricingCards;
